export default __webpack_public_path__ + "static/5-unique-ways-to-experience-french-delicacies-bread-a6ddfe46d7762695cdd9f8f8df7e5244.jpg";